import { creatorPath, creatorsByName } from '../lib/catalog';
import { Link } from './Link';

interface CreatorLinkProps {
  name: string;
  className?: string;
}

export function CreatorLink({ name, className }: CreatorLinkProps) {
  const creator = creatorsByName.get(name);
  if (!creator) return <span className={className} title={name}>{name}</span>;
  return <Link className={className ? `creator-link ${className}` : 'creator-link'} href={creatorPath(creator)} title={name}>{name}</Link>;
}
